import React from 'react'
import { Card } from 'react-bootstrap'
import styled from 'styled-components'
import { LucideIcon } from 'lucide-react'

interface ToolCardProps {
  title: string
  description: string
  icon: LucideIcon
  onClick: () => void
}

const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.colors.background.card};
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 20px rgba(102, 126, 234, 0.1);
  transition: ${({ theme }) => theme.transitions.default};
  overflow: hidden;
  backdrop-filter: blur(10px);
  position: relative;
  cursor: pointer;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.5), transparent);
    opacity: 0.6;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 35px 70px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2),
      0 0 30px rgba(102, 126, 234, 0.2);
    border-color: rgba(102, 126, 234, 0.3);
  }
`

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: rgba(102, 126, 234, 0.15);
  border: 1px solid rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  color: rgba(102, 126, 234, 1);
  transition: all 0.3s ease;

  ${StyledCard}:hover & {
    background: rgba(102, 126, 234, 0.25);
    transform: scale(1.05);
  }
`

const CardTitle = styled(Card.Title)`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #fff;
`

const CardDescription = styled(Card.Text)`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.5;
`

const CardBody = styled(Card.Body)`
  padding: ${({ theme }) => theme.spacing.md};
`

const ToolCard: React.FC<ToolCardProps> = ({ title, description, icon: Icon, onClick }) => {
  return (
    <StyledCard onClick={onClick}>
      <CardBody className="d-flex flex-column align-items-start">
        <IconWrapper>
          <Icon size={32} />
        </IconWrapper>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardBody>
    </StyledCard>
  )
}

export default ToolCard
